import { 
  PLUGIN_ADDED, PLUGIN_REMOVED, 
  CREATOR_ADDED, CREATOR_REMOVED, CREATOR_CHANGED } from './Constants.js'

const validTypes = {
  [PLUGIN_ADDED] : true,
  [PLUGIN_REMOVED] : true, 
  [CREATOR_ADDED] : true,
  [CREATOR_REMOVED] : true,
  [CREATOR_CHANGED] : true
}
/**
 * This presents an optionally filtered and sorted view of a type of plugin.
 * It will listen to the Plugins and automatically update as needed.
 * If options.processsor is defined, it will be invoked with processor the
 * type plugins. What evere value is return from it will be returned from get().
 * If options.filter and/or options.sort are returned, the value from get() will
 * be an array of plugins.
 * 
 * This will lazily calculate the view when get() is called. The calculated result 
 * will be returned until a pluginAdded, pluginRemoved event is received, in which
 * case the get() will recalculate the view.
 * 
 */
export default class View {

  constructor( plugins, type, options ) {
    const { sort = defaultSort, processor = null, filter = null } = options || { }
    
    this.plugins = plugins
    this.type = type
    this.sort = sort === 'byNumber' ? numberSort : sort
    this.filter = filter
    this.processor = processor
    this.dirty = true
    this.listeners = []
    this.listener = ( event ) => { this.onEvent( event ) }
    this.start()
  }

  start( ) {
    this.recalculate()
    this.plugins.on( this.type, this.listener )
  }

  stop( ) {
    this.plugins.off( this.type, this.listener )
  }

  /**
   * Returns the computed view of the plugins, If processPlsorted and filtered as defined.
   */
  get( ) { 
    if ( this.dirty ) {
      this.recalculate()
    }
    return this.view 
  }

  onEvent( evt ) {

    if ( validTypes[evt.type] ) {
      this.dirty = true

      const event = { type : 'isDirty', view : this }
      for ( let n = 0; n < this.listeners.length; n++ ) {
        this.listeners[n]( event )
      }
    } 
  }

  recalculate( ) {
    const plgs = this.plugins.get( this.type )
    if ( this.processor ) {
      if ( this.sort ) {
        plgs.sort( this.sort )
      }
      // allow complete control of view
      this.view = this.processor( plgs )
    } else {
      if ( this.filter ) {
        this.view = plgs.filter( this.filter )
      } else {
        this.view = [ ...plgs ]
      }
      if ( this.sort ) {
        this.view.sort( this.sort )
      }
    }
    this.dirty = false
  }

}

/**
 * Compares a to b, sorting based on strings in 'sort', 'name', 'displayName', 'type'
 */
function defaultSort( a, b ) {
  
  let an = a.sort || a.name || a.displayName || a.type
  let bn = b.sort || b.name || b.displayName || b.type
  if ( typeof an === 'function' ) {
    an = an()
  }
  if ( typeof bn === 'function' ) {
    bn = bn()
  }
  an = typeof an === 'string' ? an : 'zzzz'
  bn = typeof bn === 'string' ? bn : 'zzzz'
  
  return an.localeCompare( bn )
}

/**
 * A comparator function that compares a.sort and b.sort, assuming
 * a.sort and b.sort are numbers
 */
function numberSort( a, b ) {
  const an = a.sort || 0
  const bn = b.sort || 0
  return an - bn
}

View.defaultSort = defaultSort
View.numberSort = numberSort

export {
  defaultSort,
  numberSort
}
